var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3221 16.6418C7.2906 16.6418 5.56238 15.9294 4.13743 14.5047C2.71248 13.0797 2 11.3518 2 9.32089C2 7.29 2.71248 5.56207 4.13743 4.13712C5.56238 2.71238 7.29019 2 9.32089 2C11.3518 2 13.0797 2.71238 14.5046 4.13712C15.9296 5.56207 16.6421 7.2903 16.6421 9.32179C16.6421 10.1342 16.5225 10.8926 16.2835 11.5971C16.0446 12.3014 15.7159 12.9471 15.2975 13.5341L21.622 19.8659C21.874 20.1225 22 20.4102 22 20.7289C22 21.0478 21.8717 21.3332 21.6151 21.5852C21.3631 21.8371 21.0715 21.9631 20.7403 21.9631C20.4094 21.9631 20.1179 21.8371 19.8659 21.5852L13.5486 15.2975C12.9567 15.7157 12.3062 16.0444 11.5971 16.2835C10.8879 16.5223 10.1296 16.6418 9.3221 16.6418ZM9.32089 14.1669C10.6698 14.1669 11.8147 13.6964 12.7555 12.7555C13.6964 11.8147 14.1669 10.6698 14.1669 9.32089C14.1669 7.97193 13.6964 6.82707 12.7555 5.88631C11.8147 4.94535 10.6698 4.47487 9.32089 4.47487C7.97213 4.47487 6.82727 4.94535 5.88631 5.88631C4.94555 6.82707 4.47517 7.97193 4.47517 9.32089C4.47517 10.6698 4.94555 11.8147 5.88631 12.7555C6.82727 13.6964 7.97213 14.1669 9.32089 14.1669Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSearch);
export default __webpack_public_path__ + "static/media/input-search.be36c44d84498b2d48928a4a6d0d7dbf.svg";
export { ForwardRef as ReactComponent };